import { render, staticRenderFns } from "./recordNo.vue?vue&type=template&id=733a6796&scoped=true&"
import script from "./recordNo.vue?vue&type=script&lang=js&"
export * from "./recordNo.vue?vue&type=script&lang=js&"
import style0 from "./recordNo.vue?vue&type=style&index=0&id=733a6796&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "733a6796",
  null
  
)

export default component.exports